<template>
  <div class="d-flex flex">
    <v-spacer />
    <v-text-field
      v-model="currentQuery"
      :label="$t('list.query')"
      outlined
      dense
      single-line
      hide-details
      clearable
      style="max-width: 20rem"
    />
  </div>
</template>
<script>
const { mapMutations } = require('vuex');
export default {
  data: () => ({
    debounceTimeout: null,
    debouncedInput: ''
  }),
  props: {
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    limit() {
      return this.$store.state.AdminUserStore.pagination.find((item) => item.datatype === this.datatype)?.limit ?? 25;
    },
    query() {
      return this.$store.state.AdminUserStore.query.find((item) => item.datatype === this.datatype)?.query ?? '';
    },
    currentQuery: {
      get() {
        return this.debouncedInput;
      },
      set(val) {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.debouncedInput = val;
        }, 300);
      }
    }
  },
  methods: {
    ...mapMutations({
      setPagination: 'AdminUserStore/setPagination',
      setQuery: 'AdminUserStore/setQuery'
    })
  },
  watch: {
    currentQuery: {
      handler(newQuery) {
        this.setQuery({
          datatype: this.datatype,
          query: newQuery
        });
        this.setPagination({
          datatype: this.datatype,
          limit: this.limit,
          offset: 0
        });
      }
    },
    datatype: {
      async handler() {
        this.currentQuery = this.query;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss"></style>
